import React from 'react';
import { Trans } from 'gatsby-plugin-react-i18next';

import './key.indicators.less';
import { StaticImage } from 'gatsby-plugin-image';

const INDICATORS = [
  <StaticImage
    key="KI_02"
    src="../../images/uvery/KI_02.svg"
    alt="Key Indicator"
    title="Indicator"
  />,
  <StaticImage
    key="KI_03"
    src="../../images/uvery/KI_03.svg"
    alt="Key Indicator"
    title="Indicator"
  />,
  <StaticImage
    key="KI_04"
    src="../../images/uvery/KI_04.svg"
    alt="Key Indicator"
    title="Indicator"
  />,
  <StaticImage
    key="KI_05"
    src="../../images/uvery/KI_05.svg"
    alt="Key Indicator"
    title="Indicator"
  />,
];

const KeyIndicators = function () {
  return (
    <div className="o-keyIndicators" id="about-us">
      <div className="m-globalContentContainer m-keyIndicators__container">
        <div className="m-keyIndicators__titleContainer">
          <div className="-page-title a-landingPage__title">
            <Trans>key.indicators.title</Trans>
          </div>
        </div>
        <div className="m-keyIndicators__keyContainer -cz">
          {INDICATORS.map((Indicator, index) => (
            <div className="a-keyIndicators__indicator" key={index}>
              {Indicator}
            </div>
          ))}
        </div>
      </div>

    </div>

  );
};

KeyIndicators.propTypes = {};

export default KeyIndicators;
